import { render, staticRenderFns } from "./PortalSettings.vue?vue&type=template&id=308e0ea5&scoped=true"
import script from "./PortalSettings.vue?vue&type=script&lang=js"
export * from "./PortalSettings.vue?vue&type=script&lang=js"
import style0 from "./PortalSettings.vue?vue&type=style&index=0&id=308e0ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308e0ea5",
  null
  
)

export default component.exports